// (function($){

//     $(document).ready(function () {
        
//         var selectItem = $('.woocommerce.single-product .JonathanGreen-gift .variations_form .variations select');
//         var selectItemCalendar = $('.woocommerce.single-product .JonathanGreen-gift .variations_form .datepicker');
//         var selectItemCalendarDatePickerContainer = $('.woocommerce.single-product .JonathanGreen-gift #ui-datepicker-div');
//         var selectItemCalendarDatePicker = $('.woocommerce.single-product .JonathanGreen-gift .datepicker');
//         var selectItemCalendarItem = $('#ui-datepicker-div td > a')
//         var selectItemCalendarItemUnactive = $('#ui-datepicker-div td > span')

        
//         selectItem.on('click', function(e){
//             var $this = $(this);

//             if (($('.woocommerce.single-product .JonathanGreen-gift .variations_form .variations select').hasClass('JonathanGreen-gift-dropdown_active'))) {
//                 $('.woocommerce.single-product .JonathanGreen-gift .variations_form .variations select').removeClass('JonathanGreen-gift-dropdown_active');
//             } else {
//                 $this.addClass('JonathanGreen-gift-dropdown_active');
//             }
//             e.stopPropagation();
            
//         });
//         selectItemCalendar.on('click', function(e){
//             var $this = $(this);

//             if (($('.woocommerce.single-product .JonathanGreen-gift .variations_form .datepicker').hasClass('JonathanGreen-gift-dropdown_active'))) {
//                 // $('.woocommerce.single-product .JonathanGreen-gift .variations_form .datepicker').removeClass('JonathanGreen-gift-dropdown_active');
//             } else {
//                 $this.addClass('JonathanGreen-gift-dropdown_active');
//             }
//             e.stopPropagation();
            
//         });

//         // selectItemCalendarDatePicker.datepicker({
//         //     onSelect:function(dateText, ins) {
//         //         console.log('trigger');
//         //     }
//         // });

//         // selectItemCalendarDatePicker.datepicker().on('changeDate', function (ev) {
//         //     // $('#date-daily').change();
//         //     console.log('dsdssdsds');

//         // });
        

//         selectItemCalendarItem.on('click', function(e){
//             $('.woocommerce.single-product .JonathanGreen-gift .variations_form .datepicker').removeClass('JonathanGreen-gift-dropdown_active');
//         });
//         selectItemCalendarItemUnactive.on('click', function(e){
//             $('.woocommerce.single-product .JonathanGreen-gift .variations_form .datepicker').addClass('JonathanGreen-gift-dropdown_active');
//         });

//         $(document).on('click', function() {
//             $('.woocommerce.single-product .JonathanGreen-gift .variations_form .variations select').removeClass('JonathanGreen-gift-dropdown_active');
//             $('.woocommerce.single-product .JonathanGreen-gift .variations_form .datepicker').removeClass('JonathanGreen-gift-dropdown_active');
            
//         });

//         // $(".woocommerce.single-product .JonathanGreen-gift .variations_form .variations select").click(function (e) {
//         //     e.stopPropagation();
//         // });


//     });

// })(jQuery);
